import React from 'react';
import InpageBase from './InpageBase';

import TInpage from './types/TInpage';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Neutral = (props: TInpage) => <InpageBase {...props} signal={FeedbackSignals.Neutral} />;

export default Neutral;
